import { render } from "./LoggedHome.vue?vue&type=template&id=b4764b86&scoped=true"
import script from "./LoggedHome.vue?vue&type=script&lang=js"
export * from "./LoggedHome.vue?vue&type=script&lang=js"

import "./LoggedHome.vue?vue&type=style&index=0&id=b4764b86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4764b86"]])

export default __exports__